export const environment = {
  production: false,
  baseURL: 'https://topfanslite-stage-api.beta5.topfans.com/',
  whitelableGtag:"GTM-NK9JWNN5",
  version: '0.0.7',
  toastrConfig: {
    positionClass: 'toast-top-right',
    preventDuplicates: true,
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: true
  },
  sKey: 'JTRJHCQLOVAHTTSLAG76|AiYeUtjzs12ZX4kCUBUwI7v63lI3VQSvX1SmVTQt',
  s3Config: {
    region: 'us-east-1',
    bucketName: 'topfan-lite-stage-backend',
    bucketUrl: 'https://cdn-www6.topfan.dev/'
  },
  stripeConfig: {
    url: 'https://api.stripe.com/v1/',
    file_url: 'https://files.stripe.com/v1/',
    key: 'pk_test_51Ro0aIFL0Wk2dhbTcTXB1YQfL6wgo41yHMm0HIKe2C0hh2eMzRQs9eLk5nk7vbNqMx5az4oqigx5lofGfHvmwCMG00NZ3OSok2'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCsDqwkJPpYt1JCLfm-cE5Bt8X9alqGK1k',
    authDomain: 'topfan-dev-4da21.firebaseapp.com',
    projectId: 'topfan-dev-4da21',
    storageBucket: 'topfan-dev-4da21.appspot.com',
    messagingSenderId: '721544127250',
    appId: '1:721544127250:web:18f4c04f1c03d542c849cb',
    measurementId: 'G-NVKP4JJG9T'
  },
  firebaseVapidKey:
    'BCFJDijBvxmRzqcXnyqZDvsvp99kMFBQ0OzhRDJnIOO7PIrEFR2rb1jLG0DYFssb6ZU9-7JczjMgn_A7v0K_Q3U',
  // old google key
  // Google_Api: 'AIzaSyCn-_OYDkRcVwbRdmMyZ7_bKKGLuQgEhqU',
  Google_Api: 'AIzaSyBxoF0X7r39AErPLbe-1dK5qBn2mxTOAlY',
  webSocketUrl:
    'wss://960ze6vso0.execute-api.us-east-1.amazonaws.com/production',
  encKey: 'qwertyuiopasdfghjklzxcvbnm',
  webURL: 'https://www6.topfan.dev/',
  websiteURL: 'https://www6.topfan.dev/',
  IP_ENDPOINT: 'https://api.ipify.org?format=json',
  captchaSiteKey: '6Lc2mTQqAAAAAN20cRSwmmlPbT75VqjZiqpv1DlZ',
  MEETING_EMBED_CODE: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
  BOOK_DEMO_EMBED_FRAME: 'https://meetings-na2.hubspot.com/justin-dorsen?embed=true',
  EMBED_BASE_URL: 'https://video6.topfan.dev/',
  SECRET_KEY_IVS: "rC3FOhQxj4cZV2RIawkgvQ1WMiZn56sPgfGrBZddB5k=",
  WATCH_A_DEMO_FRAME: 'https://40igkz.share-na2.hsforms.com/2BNc_yBJLR4afJVykTr8OvA?embed=true',
  WATCH_A_DEMO_SRC: 'https://js-na2.hsforms.net/forms/embed/242726003.js',
  WATCH_A_DEMO_FORM: {
    region: 'na2',
    formId: 'eb9c69cf-c45f-416a-b1bd-d4b420ea9707',
    portalId: '242726003'
  },
  whiteLabelConfig: null,
  advertiseUrl: 'https://ads6.topfan.dev/',
  original_web_url: 'https://www6.topfan.dev/',
  MARKETING_PAGES_ROUTE: {
    MUSIC: 'music',
    HEALTH: 'health-wellness',
    ATHLETE: 'athlete',
    PROFESSIONALS: 'professionals',
    SPORTS_TEAMS: 'sports-teams'
  }
};